// Tabla 18 - Vigencia - VIG
// TransUnion - Tablas de convenciones - Información Comercial - Versión 1.34

const vigencia = {
  DEF: 'Definido',
  IND: 'Indefinido'
};

export default vigencia;
